/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An encrypted value used to record acceptance of Moov's Terms of Service.
 */
export type TermsOfServiceToken = {
  token: string;
};

/** @internal */
export const TermsOfServiceToken$inboundSchema: z.ZodType<
  TermsOfServiceToken,
  z.ZodTypeDef,
  unknown
> = z.object({
  token: z.string(),
});
/** @internal */
export type TermsOfServiceToken$Outbound = {
  token: string;
};

/** @internal */
export const TermsOfServiceToken$outboundSchema: z.ZodType<
  TermsOfServiceToken$Outbound,
  z.ZodTypeDef,
  TermsOfServiceToken
> = z.object({
  token: z.string(),
});

export function termsOfServiceTokenToJSON(
  termsOfServiceToken: TermsOfServiceToken,
): string {
  return JSON.stringify(
    TermsOfServiceToken$outboundSchema.parse(termsOfServiceToken),
  );
}
export function termsOfServiceTokenFromJSON(
  jsonString: string,
): SafeParseResult<TermsOfServiceToken, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TermsOfServiceToken$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TermsOfServiceToken' from JSON`,
  );
}
